export default "__VITE_ASSET__DbhFp8vx__"